export const GETTER_LIST_COLUMN_MAPPING = 'GETTER_LIST_COLUMN_MAPPING';
export const GETTER_COLUMN_MAPPING = 'GETTER_COLUMN_MAPPING';
export const GETTER_DEFAULT_COLUMN_MAPPING_FIELDS = 'GETTER_DEFAULT_COLUMN_MAPPING_FIELDS';

export const ACTION_GET_LIST_COLUMN_MAPPING = 'ACTION_GET_LIST_COLUMN_MAPPING';
export const ACTION_GET_COLUMN_MAPPING = 'ACTION_GET_COLUMN_MAPPING';
export const ACTION_SET_COLUMN_MAPPING = 'ACTION_SET_COLUMN_MAPPING';
export const ACTION_GET_DEFAULT_COLUMN_MAPPING_FIELDS = 'ACTION_GET_DEFAULT_COLUMN_MAPPING_FIELDS';

export const MUTATION_SET_LIST_COLUMN_MAPPING = 'MUTATION_SET_LIST_COLUMN_MAPPING';
export const MUTATION_SET_COLUMN_MAPPING = 'MUTATION_SET_COLUMN_MAPPING';
export const MUTATION_SET_LIST_DEFAULT_COLUMN_MAPPING_FIELDS = 'MUTATION_SET_LIST_DEFAULT_COLUMN_MAPPING_FIELDS';



// WEBPACK FOOTER //
// ./src/store/modules/column_mapping/constants.js